import { Skeleton } from 'primereact/skeleton';

const NdcLoadingSkeleton = () => {
  return <Skeleton height="20rem" style={{ width: '100%' }} />;
};

export default NdcLoadingSkeleton;
